import { useEffect, useRef } from 'react';

/**
 * Strongly inspired by https://www.youtube.com/watch?v=J-g9ZJha8FE.
 *
 * This hook provides the business logic to easily know if a user has clicked
 * outside a given element (elementRef)
 * */
const useClickOutside = (elementRef, onClickedOutside) => {
  // Place the callback in a ref, to ensure useEffect does
  // not trigger on every re-render.
  // We could potentially use the useCallback from outside this hook,
  // but we can assume that the callback never changes
  const callbackRef = useRef(undefined);
  callbackRef.current = onClickedOutside;

  useEffect(() => {
    const handleClickOutside = (evt) => {
      if (!elementRef || !callbackRef.current) {
        return;
      }

      if (!elementRef.current.contains(evt.target)) {
        callbackRef.current(evt);
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [elementRef, callbackRef]);
};

export default useClickOutside;
